import React from 'react'

import { Spinner } from '@welbe/web-design-system'
import { Container } from './AppointmentConfirmation.styles'

import { useAppointmentConfirmation } from './AppointmentConfirmation.hooks'
import { SuccessInfo } from 'App/components/SuccessInfo/Success'
import { ErrorInfo } from 'App/components/ErrorInfo/ErrorInfo'

export const AppointmentConfirmation = () => {
	const { isLoading, success } = useAppointmentConfirmation()

	return (
		<Container>
			{isLoading ? (
				<Spinner size="40px" />
			) : success ? (
				<SuccessInfo />
			) : (
				<ErrorInfo />
			)}
		</Container>
	)
}
